/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import PropTypes from 'prop-types';
import MuiContainer from '@mui/material/Container';

export default function Container(props) {
  return <MuiContainer maxWidth={false} sx={{ width: '100%' }} {...props} />;
}

Container.propTypes = {
  maxWidth: PropTypes.oneOf([
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    false,
    PropTypes.string,
  ]),
};